import React, { Component } from 'react';

import styled from 'styled-components';

import { Alert } from '@mui/material';

const Li = styled.li`
  word-wrap: break-word;
`;

export default class ErrorListDisplay extends Component {
  render() {
    const errors = this.props.errors || this.props.messages || ['There was an error'];
    return (
      <Alert severity="error">
        <strong>{errors.length > 1 ? 'Errors' : 'Error'}</strong>
        <ul>
          {errors.map((message, i) => (
            <Li key={i}>{message}</Li>
          ))}
        </ul>
      </Alert>
    );
  }
}
